import { BizPointPoliciesI, BizPointPoliciesResI, BizPointSettlementTicketI } from "@/types/points/api/point-target-list-api-types";
import spinnerHttpRequest from "../spinner-http-request";

/**
 * @description Biz 포인트 지급/회수 유형 리스트
 * @param params
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/Biz%20%ED%8F%AC%EC%9D%B8%ED%8A%B8/getActiveBizPointPolicies
 */
export const getBizPointTargetList = async (params: BizPointPoliciesI) => {
    const response = await spinnerHttpRequest.get<BizPointPoliciesResI[]>(
        '/biz-point/policies/active',
        {
            params,
        },
    );

    return response.data;
};

export const getTicketDetails = async (settlementId: string) => {
    const response = await spinnerHttpRequest.get<BizPointSettlementTicketI[]>(
        `/settlements/${settlementId}/tickets`
    )
    return response.data;
}
